import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { USER_PROFILE_TYPE } from '../../types';

export type UserSliceType = {
  authenticated: boolean | null;
  isFetching: boolean;
  error: null | any;
  profile: USER_PROFILE_TYPE | null;
  form: { [key: string]: string } | null;
  users: string[];
};
const initialState: UserSliceType = {
  authenticated: null,
  isFetching: false,
  error: null,
  profile: null,
  form: null,
  users: []
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (
      state,
      action: PayloadAction<{
        username: string;
        password: string;
        callback?: (success: boolean) => void;
      }>
    ) => {
      state.error = null;
      state.form = null;
      state.isFetching = true;
    },
    loginSuccess: (state, action: PayloadAction<{ profile?: USER_PROFILE_TYPE }>) => {
      state.authenticated = true;
      state.isFetching = false;
      state.error = null;
      if (action.payload?.profile) {
        state.profile = action.payload.profile;
      }
    },
    loginFailure: (
      state,
      action: PayloadAction<{
        code: string | null;
        form: { [key: string]: string } | null;
      }>
    ) => {
      state.authenticated = false;
      state.error = action.payload.code;
      state.form = action.payload.form;
      state.isFetching = false;
    },
    logout: (state) => {
      state.isFetching = true;
    },
    logoutSuccess: (state) => {
      state.authenticated = false;
      state.isFetching = false;
      state.profile = null;
      state.error = null;
      state.form = null;
    },
    setAuthFromStorage: (state, action: PayloadAction<{ authenticated: boolean; profile?: USER_PROFILE_TYPE }>) => {
      state.authenticated = action.payload.authenticated;
      if (action.payload.profile) {
        state.profile = action.payload.profile;
      }
    },
    clearUserState: (state) => {
      return { ...initialState };
    }
  }
});

export const { loginFailure, loginSuccess, login, logout, logoutSuccess, setAuthFromStorage } = userSlice.actions;

export default userSlice.reducer;
